import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Branch {
  _id: string;
  name: string;
  dispatch_start_time?: string | undefined;
}

type UserStore = {
  branch?: Branch;
  setBranch: (branch?: Branch) => void;
};

export const useUserZStore = create<UserStore>()(
  persist(
    (set) => ({
      branch: undefined,
      setBranch: (branch?: Branch) => set({ branch }),
    }),
    {
      name: 'voyager-user-store', // name of the item in the storage (must be unique)
    },
  ),
);
